import { Helmet } from 'react-helmet';
import React, { useEffect } from 'react';
import useCampaignData from '../data/useCampaignData';
import useProfile from '../data/useProfile';
import { useSelectorQueryApp } from '../reducers/appReducer';
import ReactHtmlParser from 'react-html-parser';
//import launchZenDesk from '../script/zendesk';
//import useTranslation from '../hooks/useTranslation';

const Header = React.memo(() => {
	const { data } = useCampaignData();
	const consents = useSelectorQueryApp('consents');
	const { data: profile } = useProfile();

	/*	const { t } = useTranslation();

    const {
        data: { email, firstName, lastName },
    } = useProfile();*/

	/*const $zopimName = lastName && firstName ? `${firstName} ${lastName}` : undefined;
    const $zopimMail = email ?? undefined;
    const $zopimTag = data.product;
    const $zopimDpt = 'Candidat';
    const $zopimOnline = t("You logged in – do you need any help?");*/

	useEffect(() => {
		if (profile?.consents?.eula || consents || data.mobileURLRedirection) {
			ReactHtmlParser(data.supportChatScript, {
				transform: (domNode) => {
					if (['script', 'style'].includes(domNode.type)) {
						let element = document.createElement(domNode.type);

						Object.entries(domNode.attribs).forEach(([key, value]) => {
							element[key] = value;
						});
						if (domNode.children && domNode.children.length) {
							if (domNode.type === 'script') {
								element.text = domNode.children[0].data;
							}
							if (domNode.type === 'style') {
								element.innerHTML = domNode.children[0].data;
							}
						}
						document.head.appendChild(element);
					}
				},
			});
		}
	}, [consents, data.mobileURLRedirection, data.supportChatScript, profile?.consents?.eula]);

	return (
		<Helmet htmlAttributes={{ lang: data.locale.split('-')[0] }}>
			<title>{data?.title ?? 'iCIMS'}</title>
		</Helmet>
	);
});

export default Header;
